import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";
import MapIcon from "@mui/icons-material/Map";
import BarChartIcon from "@mui/icons-material/BarChart";
import PeopleIcon from "@mui/icons-material/People";
import { useAuth } from "@/auth/AuthContext";

export default function ReportsHome() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  if (loading) return null;
  if (!user?.is_superuser) return <Navigate to="/search" replace />;

  return (
    <Box sx={{ px: 2, pb: 3 }}>
      <Stack spacing={2}>
        <Paper elevation={1} sx={{ p: 2 }}>
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
            <Stack spacing={0.5}>
              <Typography variant="subtitle1">Maps</Typography>
              <Typography variant="body2" color="text.secondary">
                View note locations and stats.
              </Typography>
            </Stack>
            <Button variant="contained" startIcon={<MapIcon />} onClick={() => navigate("/reports/maps")}>
              Open
            </Button>
          </Stack>
        </Paper>

        <Paper elevation={1} sx={{ p: 2 }}>
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
            <Stack spacing={0.5}>
              <Typography variant="subtitle1">Status</Typography>
              <Typography variant="body2" color="text.secondary">
                Status breakdown by day/week/month.
              </Typography>
            </Stack>
            <Button variant="contained" startIcon={<BarChartIcon />} onClick={() => navigate("/reports/status")}>
              Open
            </Button>
          </Stack>
        </Paper>

        <Paper elevation={1} sx={{ p: 2 }}>
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
            <Stack spacing={0.5}>
              <Typography variant="subtitle1">Agent</Typography>
              <Typography variant="body2" color="text.secondary">
                Compare agents over time.
              </Typography>
            </Stack>
            <Button variant="contained" startIcon={<PeopleIcon />} onClick={() => navigate("/reports/agent")}>
              Open
            </Button>
          </Stack>
        </Paper>
      </Stack>
    </Box>
  );
}
